import * as types from '../actiontypes';
import { promiseAreas } from '../../util/uiconstants';

export function addMember(url,payload) {
	return {
		type: types.ADD_MEMBER,
		meta: {
			api: {
				url,
				method: 'POST',
				data: payload,
				trackWithArea: promiseAreas.ADD_MEMBER_TO_GROUP
			}
			},		
		    payload: payload
		};
	}

	export function updateMember(url,payload) {
		return {
			type: types.UPDATE_MEMBER,
			meta: {
				api: {
					url,
					method: 'PUT',
					data: payload
				}
				},		
				payload: payload
			};
		}

	export function deleteMember(url,payload) {
		return {
			type: types.DELETE_MEMBER,
			meta: {
				api: {
					url,
					method: 'DELETE',
					trackWithArea: promiseAreas.USER_PROJECTS_AREA
				}
				}
			};
		}
